import { gql } from "@apollo/client";

import { Category } from "../types";

export const getExercisesQuery = gql`
    query GetExercises($discreet: Boolean, $categories: [Category!], $ids: [Int!], $excludedIds: [Int!]) {
        exercises(discreet: $discreet, categories: $categories, ids: $ids, excludedIds: $excludedIds) {
            id
            nameDe
            nameEn
            category
            image
            descriptionDe
            descriptionEn
            equipmentDe
            equipmentEn
            recommendationDe
            recommendationEn
            source
            discreet
        }
    }
`;

export interface GetExercisesQueryType {
    exercises: Array<{
        id: number;
        nameDe: string;
        nameEn: string;
        category: Category;
        image: string;
        descriptionDe: string;
        descriptionEn: string;
        equipmentDe: string | undefined;
        equipmentEn: string | undefined;
        recommendationDe: string;
        recommendationEn: string;
        source: string | undefined;
        discreet: boolean;
    }>;
}

export interface GetExercisesQueryVariables {
    discreet?: boolean;
    categories?: Category[];
    ids?: number[];
    excludedIds?: number[];
}

export const exercisesTableQuery = gql`
    query GetExercisesTable {
        exercisesTable {
            id
            nameDe
            nameEn
            category
            image
            descriptionDe
            descriptionEn
            equipmentDe
            equipmentEn
            recommendationDe
            recommendationEn
            source
            discreet
        }
    }
`;

export interface ExercisesTableQueryType {
    exercisesTable: Array<{
        id: number;
        nameDe: string;
        nameEn: string;
        category: Category;
        image: string;
        descriptionDe: string;
        descriptionEn: string;
        equipmentDe: string | undefined;
        equipmentEn: string | undefined;
        recommendationDe: string;
        recommendationEn: string;
        source: string | undefined;
        discreet: boolean;
    }>;
}

export const deleteExerciseMutation = gql`
    mutation DeleteExercise($id: ID!) {
        deleteExercise(id: $id)
    }
`;
